<template>
  <div class="card-wrapper pointer">
    <div class="card">
      <div class="avatar-img-wrapper">
        <img :src="coverImage(token)" alt="Thumbnail" class="app-card-image" />
      </div>
      <div class="app-card-content">
        <div class="app-card-content-description">
          <p class="app-card-title">{{ token.name }}</p>
          <div class="app-card-pool">
            <p class="app-card-pool-name" v-if="token.pool_price">
              {{ token.pool }}
            </p>
            <p class="app-card-pool-price" v-if="token.pool_price">
              {{ token.pool_price }} THEOS
            </p>
            <p class="app-card-pool-price" v-else>Not pooled</p>
          </div>
        </div>
        <div class="app-card-price" v-if="isPooled">
          <span class="app-card-token-price">{{ token.price }} THEOS</span> ${{
            token.usd
          }}
        </div>
        <div class="app-card-price" v-else></div>
      </div>
      <div class="creator-img" v-if="token.creator">
        <div class="creator-tooltip">
          Creator: {{ token.creator.displayName }}
        </div>
        <img :src="creatorAvatarImage(token.creator)" alt="Creator" />
      </div>
      <div class="owner-img" v-if="!!token.owners && token.owners.length > 0">
        <div class="owner-tooltip">
          Owner: {{ token.owners[token.owners.length - 1].displayName }}
        </div>
        <img :src="ownerAvatarImage(token)" alt="Owner" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import imageTransformer from "../plugins/imageTransformer";
import useProfilePanels from "@/composables/useProfilePanels";
export default {
  props: {
    token: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const { theosMinted } = useProfilePanels(useStore());
    const isPooled = computed(() => props.token.pool_price);

    const creatorAvatarImage = (creator) => {
      if (creator.avatarFileName)
        return imageTransformer.transform(
          creator.avatarFileName.filename,
          "user.avatar"
        );
      else if (creator.avatarImageUrl) return creator.avatarImageUrl;
      else return require("@/Common/Icons/Avatar.png");
    };

    const ownerAvatarImage = (owner) => {
      try {
        if (owner?.owners)
          return imageTransformer.transform(
            owner.owners[owner.owners.length - 1].avatarFileName.filename,
            "user.avatar"
          );
        else if (owner?.owner) return owner.owner.avatarImageUrl;
        else return require("@/Common/Icons/Avatar.png");
      } catch (error) {
        return require("@/Common/Icons/Avatar.png");
      }
    };

    const coverImage = (token) => {
      if (theosMinted.value)
        return token?.coverImage && token?.coverImage?.filename
          ? imageTransformer.transform(token.coverImage.filename, "nft.list")
          : null;
      return token.coverImageURL;
    };
    return {
      isPooled,
      coverImage,
      creatorAvatarImage,
      ownerAvatarImage,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/nftCard.scss"></style>
